import { ROLES } from '@config/constants/roles';
import { TBrand } from '@global-types/api/api';
import { apiClient } from '@lib/api-client';
import { useAuthorization } from '@lib/authorization';
import { useQuery } from '@tanstack/react-query';

export interface ApiResponse {
	rows: TBrand[];
	total: number;
	page: number;
	pageSize: number;
	totalPages: number;
}

export const getBrands = (): Promise<ApiResponse> => {
	return apiClient.get('/brands', {
		params: {
			pageSize: 100,
			sort: 'name',
		},
	});
};

export const useBrands = () => {
	const { checkRole } = useAuthorization();
	const { data, isFetching, isFetched, isPending } =
		useQuery({
			queryKey: ['brands'],
			queryFn: () => {
				return getBrands();
			},
			enabled: !checkRole([
				ROLES.PRODUCER_ADMIN,
				ROLES.PRODUCER_STAFF,
			]),
		});

	const updateList = (brands: TBrand[]) =>
		brands && Array.isArray(brands)
			? brands.reduce(
					(acc: TBrand[], currentItem: TBrand) => {
						const modifiedItem = {
							...currentItem,
						};
						acc.push(modifiedItem);

						return acc;
					},
					[]
				)
			: [];

	return {
		data: data ? updateList(data?.rows) : [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		isFetching,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
		isPending,
	};
};
